:host {
  font-family: var(--pl-font-family);
  font-size: var(--pl-font-size);
  color: var(--pl-color-fg-default);
}

*, *:before, *:after {
  box-sizing: inherit;
}

.viewport-margins {
  width: 100%;
  max-width: var(--pl-viewport-margins-max-width);
  margin: 0 auto;
  padding: 0 var(--pl-viewport-margins-gutter, 1em);
}

a {
  color: var(--color-fg-menu);
}

*:focus {
  box-shadow: 0 0 0 2px var(--pl-color-bg-accent), 0 0 0 4px var(--pl-color-bg-accent-emphasis);
  outline: none;
}

/* Header base styles */
.website-header {
  --color-fg-service: var(--pl-color-penn-blue);
  --color-fg-menu: var(--pl-color-fg-default);
  --color-bg-menu: var(--pl-color-bg-default);
}

.website-header--dark {
  --color-fg-service: var(--pl-color-fg-on-emphasis);
  --color-fg-menu: var(--pl-color-fg-on-emphasis);
  --color-bg-menu: var(--pl-color-penn-blue);
}

/* Logo and service name */
.website-header__logo-name-container {
  display: flex;
  align-items: stretch;
  margin-right: auto;
}

@media (max-width: 620px) {
  .website-header__logo-name-container {
    margin-right: 6em;
    flex-direction: column;
    gap: 0.5rem;
  }
}

.website-header_logo-link {
  line-height: 0;
}

.website-header__logo {
  max-width: 260px;
  margin-right: 1em;
}

@media (max-width: 1000px) {
  .website-header__logo {
    max-width: 200px;
  }
}

@media (max-width: 620px) {
  .website-header__logo {
    max-width: 190px;
  }
}

.website-header__service-link {
  display: flex;
  justify-content: center;
  flex-direction: column;
  text-decoration: none;
  line-height: 1;
  color: var(--color-fg-service);
}

@media (min-width: 1001px) {
  .website-header__service-link {
    padding-left: 0.5em;
  }
}

.website-header__hero .website-header__service-link {
  border-left: none;
}

.website-header__service-link:hover .website-header__service-name {
  text-decoration: underline;
  text-decoration-thickness: 2px;
  text-underline-offset: 0.1em;
  text-decoration-color: var(--color-fg-service);
}

.website-header__service-name {
  font-size: 1.5em;
  font-weight: 500;
}

.website-header__service-lede {
  font-size: 1em;
}

/* Layout containers */
.website-header__inner-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
  padding: 1em 0;
}

@media (max-width: 1000px) {
  .website-header__inner-container {
    flex-direction: column;
    align-items: flex-start;
  }
}

/* Navigation */
@media (max-width: 1000px) {
  .website-header__navigation {
    width: 100%;
  }
}

.website-header__navigation-list {
  list-style: none;
  display: flex;
  margin: 0;
  padding: 0;
}

@media (max-width: 1000px) {
  .website-header__navigation-list {
    display: none;
  }
}

@media (max-width: 1000px) {
  .website-header__navigation-list--visible {
    display: block;
    margin-top: 1rem;
  }

  .website-header__navigation-list--visible a {
    display: inline-block;
  }
}

.website-header__navigation-list button {
  background-color: transparent;
  border-width: 0;
  font-family: inherit;
  font-size: inherit;
  font-style: inherit;
  font-weight: inherit;
  line-height: inherit;
  padding: 0;
  color: inherit;
}

.website-header__navigation-list a,
.website-header__navigation-list button {
  display: block;
  text-decoration: none;
  cursor: pointer;
}

@media (max-width: 1000px) {
  .website-header__navigation-list a,
  .website-header__navigation-list button {
    padding: 0.75em 0;
  }
}

.website-header__navigation-list--visible a,
.website-header__navigation-list--visible button {
  padding: 0.5em 0;
}

@media (min-width: 1001px) {
  .website-header__navigation-list a,
  .website-header__navigation-list button {
    padding: 0.5em;
  }
}

.website-header__navigation-list a:hover,
.website-header__navigation-list button:hover {
  text-decoration: underline;
  text-underline-offset: var(--pl-link-text-underline-offset);
}

.website-header__navigation-button {
  all: unset;
  text-transform: uppercase;
  font-size: 0.75em;
  letter-spacing: 0.075em;
  font-weight: 600;
  padding: 0.5em;
  border-radius: 0.25em;
  position: absolute;
  right: 0;
  top: 1.5em;
  display: flex;
  align-items: center;
  color: var(--color-fg-service);
  cursor: pointer;
}

@media (min-width: 1001px) {
  .website-header__navigation-button {
    display: none;
  }
}

.website-header__navigation-button[aria-expanded=true] svg {
  rotate: 180deg;
}

@media print {
  .website-header__inner-container > *:not(.website-header__logo-name-container) {
    display: none;
  }
}